import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsSuperscriptSvg } from './WpsSuperscriptSvg'

export const WpsSuperscriptIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={WpsSuperscriptSvg} {...props} />
)
